import { Component, OnInit, Inject, ViewEncapsulation, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/shared/services/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { displayErrorMessage } from 'src/app/theme/utils/util-functions';
import { environment } from 'src/environments/environment';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { checkDeliveryCalenderAndCutOffTime, calculateAvailableQuantityFast, checkDeliveryCalenderAndCutOffTimes } from 'src/app/theme/utils/util-functions';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { DatePipe, DecimalPipe } from '@angular/common';
import { SharedDataService } from '../../services/sharedata.service';
import { isTokenExpiryEnabled, logoutUser } from 'src/app/theme/utils/feature-tag';

@Component({
  selector: 'app-cart-dialog',
  templateUrl: './cart-dialog.component.html',
  styleUrls: ['./cart-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CartDialogComponent implements OnInit {
  public count: number = 1;
  buttonOptions = {}
  addToCartButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Add to Order',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
    customClass: 'btn-add'
  }
  editCartButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Update Order',
    buttonColor: 'primary',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  }
  managRecurringCartButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Manage Recurring Items',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  }
  addToSeasonalProductButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Pre-Order Now',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
    customClass: 'btn-add'
  }
  outOfStockButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Sold Out',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: true,
    mode: 'indeterminate',
    customClass: 'btn-add'
  }
  customQuantity;
  loggegIn;
  minQty;
  title: string;
  maxQty;
  width = '80%';
  submitted = false;
  uom;
  currentIndex = 0;
  storeDetails = {};
  showFrequencyError = false;
  showQuantityError = false;
  showSeasonalEventError = false;
  nextIndex = 1;
  previousIndex = 0;
  selectedDeliveryCalendar= {};
  frequencyControl = new FormControl('', Validators.required);
  quantityControl = new FormControl(1, Validators.required);
  seasonalEventsControl = new FormControl('', Validators.required);
  // startDateControl = new FormControl('');
  startDateControl = new FormControl(null, [Validators.required]);
  imageUrl = environment.imageUrl;
  quantities = [];
  frequencies = [];
  cutOffTime= [];
  localStorageCartProd;
  availableQuantities = [];
  displayedQuantities = [];
  url = this.router.url.split('?')[0];
  orderPresent = false;
  extendedPrice = 0;
  temporaryQuantityValue = 0;
  seasonalProductEvents = [];
  featureTags = {};
  batchSize = 25; 
  lastLoadedIndex = 0;
  isButtonDisabled: boolean = false;

  isSaleOrderSaving :boolean =false; 
  isLoadingSaveOrderBtn = false;
  paymentMethodsType:any = [];
  userDetails = {};
  frequencyMsg:string=""
  frequencyDates =[];
  isStartDate:boolean = false
  isMultiSelect:boolean = false
  selectedFrequencies: string[] = []
  eventDetails = []
  eventDates = []
  setdefaultOption:any





  constructor(@Inject(MAT_DIALOG_DATA) public product: any, 
  public dialogRef: MatDialogRef<CartDialogComponent>, 
  private apiService: ApiService, 
  private dialog: MatDialog,
  private router: Router, 
  private notification: NotificationService, 
  private subscription: SubscriptionService, 
  private activatedRoute: ActivatedRoute,
  private decimalPipe: DecimalPipe,
  public sharedDataService: SharedDataService,
  private datePipe: DatePipe

 ) {
    this.availableQuantities = calculateAvailableQuantityFast(this.product);
  }

  ngOnInit() {
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));   
    this.selectedDeliveryCalendar = JSON.parse(sessionStorage.getItem('selected_delivery_calendar')); 
    this.cutOffTime = JSON.parse(sessionStorage.getItem('cutoff')); 
    this.loggegIn = this.apiService.loggedIn();
    this.storeDetails = this.product['storeDetails'];
    if(!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){
    this.paymentMethodsType = this.sharedDataService.paymentDetails;
    this.sharedDataService.emitSaveOrder$.subscribe((res:any) => {
      if(res){
        this.saveOrderFunction();
      }
    });
    }
    this.localStorageCartProd =  JSON.parse(sessionStorage.getItem('cart'));
    this.eventDetails = JSON.parse(sessionStorage.getItem("event_details") ?? "[]");
    this.eventDates = this.eventDetails.map(event => ({
      event_id: event.event_id,
      event_date: event.event_date
    }));
    this.loadMoreQuantities();
    this.productFrequencies(); 
    if(this.product['product']) {     
      // if (this.featureTags['seasonal_products'] === true) {
        this.seasonalProductEvents = this.product['product']['seasonal_product_evnts'] ? this.product['product']['seasonal_product_evnts'] : [];
        if(this.seasonalProductEvents.length>0){
          this.seasonalEventsControl.setValue(this.seasonalProductEvents[0]['event_delivery_date']);
        }
      // }

      /// set default quantity and frequency value
    //  let productCart = this.product['cart'];
      this.quantityControl.setValue(this.availableQuantities[0]);
      /// end

      this.uom = this.product['product']['cb_unit_of_measurement']['name'];
      var value = {
        product_id:  this.product['product']['id']
      }
      
      this.title = 'Add To Order';        
      this.minQty = this.availableQuantities[0];
      this.quantityControl.setValue(this.minQty);
    }

  }

  productFrequencies() {
    if(!!this.featureTags && this.featureTags['sf_product_based_recurring_frequency']){
      const upcomingEvents = JSON.parse(sessionStorage.getItem("event_details") ?? "[]");
      const frequencies = JSON.parse(sessionStorage.getItem("recurring_frequencies") ?? "[]");
      const productFrequencies = this.product?.product?.product_frequency ?? [];
    
      // Default frequency if no events or frequencies exist
      if (frequencies.length === 0 && upcomingEvents.length === 0) {
        this.frequencies = [{ viewValue: "This Week", frequency: "One Time Only" }];
        this.frequencyControl.setValue(this.frequencies[0]);
        return;
      }
    
      // Filter events for "This Week" and "Next Week"
      const filteredEvents = upcomingEvents
        .filter(event => event.weeks === "This Week" || event.weeks === "Next Week")
        .map(event => ({
          ...event,
          viewValue: event.weeks,
          frequency: frequencies.includes("One Time Only") ? "One Time Only" : null,
        }));
    
      if (productFrequencies.includes("all")) {
        // Add all frequencies except "One Time Only"
        const additionalFrequencies = frequencies
          .filter(freq => freq !== "One Time Only")
          .map(freq => ({ event_id: null, viewValue: freq, frequency: freq }));
    
        this.frequencies = [...filteredEvents, ...additionalFrequencies];
      } else {
        let matchingFrequencies = productFrequencies
          .filter(freq => frequencies.includes(freq) && freq !== "One Time Only") // Exclude "One Time Only"
          .map(freq => ({ event_id: null, viewValue: freq, frequency: freq }));

        // If "One Time Only" exists in productFrequencies, add "Others"
        if (productFrequencies.includes("One Time Only")) {
          matchingFrequencies.push({ event_id: null, viewValue: "Others", frequency: "Others" });

          // Only include filteredEvents if "One Time Only" exists in productFrequencies
          this.frequencies = [...filteredEvents, ...matchingFrequencies];
        } else {
          this.frequencies = [...matchingFrequencies];
        }


      }
    
      this.frequencyControl.setValue(this.frequencies[0] || null);
      this.frequencyValidation();
    }else{
      // Parse upcoming events and frequencies from session storage
       const upcomingEvents = JSON.parse(sessionStorage.getItem("event_details") ?? "[]");
       const frequencies = JSON.parse(sessionStorage.getItem("recurring_frequencies") ?? "[]");
   
       // Filter events for "This Week" and "Next Week"
       if(frequencies.length > 0 || upcomingEvents.length > 0){
         const filteredEvents = upcomingEvents
         .filter(event => event.weeks === "This Week" || event.weeks === "Next Week")
         .map(event => ({
           ...event,
           viewValue: event.weeks,
           frequency: frequencies.includes("One Time Only") ? "One Time Only" : null,
         }));
   
       // Add any remaining frequencies other than "One Time Only" to the list
       const additionalFrequencies = frequencies
         .filter(freq => freq !== "One Time Only")
         .map(freq => ({
           event_id: null, // No event ID for general frequencies
           viewValue: freq,
           frequency: freq,
         }));
   
       // Combine filtered events and additional frequencies
       this.frequencies = [...filteredEvents, ...additionalFrequencies];
   
       this.frequencyControl.setValue(this.frequencies[0]);
       }else{
         this.frequencies = [
           { viewValue: 'This Week', frequency: 'One Time Only' }
         ];
         this.frequencyControl.setValue(this.frequencies[0]);
      }
    }
   
  }
  
  
  

  buySeasonalProduct(){
    var seasonal_product = [];
    if(this.quantityControl.invalid) {
      this.showQuantityError = true;
    }
    if(this.seasonalEventsControl.invalid) {
      this.showSeasonalEventError = true;
    }
    if(this.quantityControl.valid && this.seasonalEventsControl.valid) {
     // sessionStorage.setItem('deliveryFeeAlert', 'hide');
     if(this.product && this.quantityControl.value) {
      this.product['quantity'] = this.quantityControl.value;
      this.product['selected_delivery_date'] = this.seasonalEventsControl.value; 
      this.product['bottleQty'] =  this.product['product']['bottle_charge'] ? '1' : '0';
      this.product['retail_price'] =  this.product['product']['retail_price'];
      this.product['extendedprice'] =  this.product['product']['retail_price'];
      this.product['description'] =  this.product['product']['description'];

      //Check this product is already exist in order and save this params in sessionStorage  
      if (!!this.product['product']['is_pre_order'] && this.product['product']['is_pre_order']) {
        this.product['order_quantity'] = this.product['product']['order_quantity'];
        this.product['order_id'] = this.product['product']['order_id'];
        this.product['sale_order_id'] = this.product['cart']['id'];
      }
      seasonal_product.push(this.product);
      if(this.apiService.loggedIn() === false) {
        localStorage.setItem('pre_order_item', JSON.stringify(seasonal_product));
      }
      if(this.apiService.loggedIn() === true) {
        sessionStorage.setItem('pre_order_item', JSON.stringify(seasonal_product));
      }
      //Check this product is already exist in order 
      if(!!this.product['product']['is_pre_order'] && this.product['product']['is_pre_order']){
        this.notification.warning('This product already exist in the order', 5000);
      }

      this.dialogRef.close();
      this.router.navigate(['pre-cart']);
     }
    }
    
    
  }

  saveOrderFunction(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.isButtonDisabled = true;

      if (this.apiService.loggedIn() === false) {
        this.close();
        var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
          this.router.navigate(['sign-in'], queryParams);
        return;
      }
      if (this.isStartDate) {
        this.startDateControl.markAsTouched();
        if (this.startDateControl.invalid) {
          console.log('Form is invalid. Please select one or more dates.');
          return;
        } else {
          console.log('Form is valid. ');
        }
      }
          
    this.isSaleOrderSaving = true;
    // this.concatArray = this.cartProducts.concat(this.currentWeekRecurringProducts);
    if(!!this.eventDetails && this.eventDetails.length > 0){
    var data = {}    
      data = {
        product_id: this.product['product']['id'],
        quantity: !!this.product['product']['sell_in_uof'] && this.product['product']['sell_in_uof'] === 'unit' ? this.quantityControl.value : this.quantityControl.value,
        frequency: this.frequencyControl.value.frequency === 'Others' ? 'One Time Only' : this.frequencyControl.value.frequency,
        is_recurring: 0,
      };
      
      if (this.isStartDate) {
        // If isStartDate is true, map delivery_details with event_id and event_date
        
        data['delivery_details'] = this.frequencyControl.value.frequency === 'Others' ? this.startDateControl.value : [this.startDateControl.value]
      } else {
        // If isStartDate is false, set a single object with event_id and event_date
        data['delivery_details'] = [{
          event_id: this.frequencyControl.value.event_id,
          event_date: this.frequencyControl.value.event_date
        }];
      }

    this.isLoadingSaveOrderBtn = true;    
    this.apiService.saveOrder(data).subscribe(result => {
      if (result['response']['status'] === 0) {
        this.isButtonDisabled = false;
        reject(result);
        this.dialog.open(PopupComponent, {
          maxWidth: '96vw',
          width: '450px',
          data: { msg: 'out of stock product popup', displayMessage: result['response']['message'] }
        });
        this.isLoadingSaveOrderBtn = false;
      } else if (result['response']['status'] === 1) {
        if(!!this.featureTags && this.featureTags['ftag_first_order_spl_msg']){
          if (result['response']['data']['saleData'] && result['response']['data']['saleData']['first_order_special_message'] === 1) {
            this.dialog.open(PopupComponent, {
              maxWidth: '96vw',
              width: '450px',
              data: {
                msg: 'first order message',
                displayMessage: result['response']['message']
              }
            });
          }else{
            this.notification.success(result['response']['message'], 5000);
          }
          localStorage.removeItem('specialInstruction');
          this.subscription.subjectNext({ msg: "set delivery calendar order status", status: "undelivered" });
          this.subscription.subjectNext({ value: 'Get order' });
          // this.router.navigate(['account/orders']);
          this.sharedDataService.getOrderData();
          this.sharedDataService.cartResponse$.next(true);
          this.dialogRef.close({value: 'confirm', logged: 'yes', product :this.product})
          resolve(result);
          this.isButtonDisabled = false;
        }else{
          localStorage.removeItem('specialInstruction');
          this.notification.success(result['response']['message'], 5000);
          this.subscription.subjectNext({ msg: "set delivery calendar order status", status: "undelivered" });
          this.subscription.subjectNext({ value: 'Get order' });
          // this.router.navigate(['account/orders']);
          this.sharedDataService.getOrderData();
          this.sharedDataService.cartResponse$.next(true);
          this.dialogRef.close({value: 'confirm', logged: 'yes', product :this.product})
          resolve(result);
          this.isButtonDisabled = false;
        }
      } else if (result['response']['status'] === 2) {
        reject(result);
        this.dialog.open(PopupComponent, {
          maxWidth: '96vw',
          width: '450px',
          data: { msg: 'vacation date present', displayMessage: result['response']['message'] }
        });
        if(!!this.featureTags && this.featureTags['sf_vacation_saveorder_button']){
          this.isButtonDisabled = false;
        }else{
          this.isLoadingSaveOrderBtn = false;
        }
      } else if (result['response']['status'] === 3) {
        this.isButtonDisabled = false;
        displayErrorMessage({
          notification: this.notification,
          response: result['response']
        });
        this.isLoadingSaveOrderBtn = false;
        reject(result);
      } else if (result['response']['status'] === 4) {
        this.isButtonDisabled = false;
        if (result['response']['message'].includes('cutoff')) {
          const dialogRef = this.dialog.open(PopupComponent, {
            width: '450px',
            data: { display: result['response']['message'], msg: 'cut off time error' }
          });
        } else if (result['response']['message'].includes('skipped')) {
          const dialogRef = this.dialog.open(PopupComponent, {
            width: '450px',
            data: { display: result['response']['message'], msg: 'order skipped' }
          });
        }
        else if (result['response']['message'].includes('already added this product to your order') && !!this.featureTags && this.featureTags['ftag_allow_multiple_product_so']) {
          const dialogRef = this.dialog.open(PopupComponent, {
            width: '450px',
            data: { display: result['response']['message'], msg: 'existing product' }
          });
        }
        else if (result['response']['message'].includes('already added this product to your recurring')  && !!this.featureTags && this.featureTags['ftag_allow_multiple_product_so']) {
          const dialogRef = this.dialog.open(PopupComponent, {
            width: '450px',
            data: { display: result['response']['message'], msg: 'existing recurring' }
          });
        }
        this.isLoadingSaveOrderBtn = false;
        reject(result);
      } else if (result['response']['status'] === 6) {
        this.dialogRef.close();
        this.isButtonDisabled = false;
        reject(result);
        // localStorage.setItem('specialInstruction', this.specialInstruction);
        if (result['response']['message'] === 'Contact Address information not found') {
          this.router.navigate(['account/addresses'], { queryParams: { from: 'saveOrder' } });
          this.subscription.behSubjectNext({ orderMsg: 'Require Contact information' });
        }
        // if (result['response']['message'] === 'Notes is Not Found' && this.userDetails['delivery_preference']?.toLowerCase() === 'delivery') {
        if (result['response']['message'] === 'Notes is Not Found') {
          this.addDeliveryInstruction('add');
          this.isLoadingSaveOrderBtn = false;
        }
        if(!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){
          if (result['response']['message'] === 'Credit card Not Found') {
              this.subscription.behSubjectNext({ orderMsg: 'Credit card Not Found' });
              const dialogRef = this.dialog.open(PopupComponent, {
                maxWidth: '96vw',
                width: '450px',
                data: { msg: 'Credit card Not Found' }
              });
              dialogRef.afterClosed().subscribe(result => {
                if (result == true) {
                  this.isSaleOrderSaving = true;
                  setTimeout(() => {
                    this.isSaleOrderSaving = false;
                  }, 5000);
                }
              });
            
  
          }else if(result['response']['message'].includes('pay later')){
            console.log('pay later');
              const dialogRef = this.dialog.open(PopupComponent, {
                maxWidth: '96vw',
                width: '450px',
                data: { msg: 'Cash On Delivery' }
              });
              dialogRef.afterClosed().subscribe(result => {
                if (result == true) {
                  this.isSaleOrderSaving = true;
                  setTimeout(() => {
                    this.isSaleOrderSaving = false;
                  }, 5000);
                  //this is to avoid the save alert popup
                }
              });
            
          }
        }else{
        if (result['response']['message'] === 'Credit card Not Found') {
          if (!!this.paymentMethodsType.find(val => val['name'] === 'cash') === false) {
            this.subscription.behSubjectNext({ orderMsg: 'Credit card Not Found' });
            const dialogRef = this.dialog.open(PopupComponent, {
              maxWidth: '96vw',
              width: '450px',
              data: { msg: 'Credit card Not Found' }
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result == true) {
                this.isSaleOrderSaving = true;
                setTimeout(() => {
                  this.isSaleOrderSaving = false;
                }, 5000);
                //this is to avoid the save alert popup
              }
            });
          } else {
            this.subscription.behSubjectNext({ orderMsg: 'Credit card Not Found' });
            const dialogRef = this.dialog.open(PopupComponent, {
              maxWidth: '96vw',
              width: '450px',
              data: { msg: 'Credit card Not Found' }
            });
            dialogRef.afterClosed().subscribe(result => {
              if (result == true) {
                this.isSaleOrderSaving = true;
                setTimeout(() => {
                  this.isSaleOrderSaving = false;
                }, 5000);
              }
            });
          }

        }

      }
        this.isLoadingSaveOrderBtn = false;
        // this.notification.success(result['response']['message']);
      } else if (result['response']['status'] === 22) {
        // For logged out user from server
        if (isTokenExpiryEnabled(this.featureTags)) {
          this.dialogRef.close({value: '', product: ''});
          logoutUser(this.apiService, this.router, this.notification)
        }
      } else {
        this.notification.warning(result['response']['message'], 5000);
        this.isLoadingSaveOrderBtn = false;
        this.isButtonDisabled = false;
        reject(result);
      }
    }, (error) => {
      if (error) {
        this.isButtonDisabled = false;
        this.isLoadingSaveOrderBtn = false;
        console.log(error);
      }
    });
  }else{
    this.notification.warning('Event Date Not Found', 5000);
    this.isSaleOrderSaving = false;
    this.isButtonDisabled = false;

  }
  })
    
  }

  addDeliveryInstruction(value) {
    var message = value === 'add' ? 'add delivery instruction' : 'update delivery instruction'
    const dialogRef = this.dialog.open(PopupComponent, {
      width: '450px',
      data: {
        msg: message,
        // deliveryInstruction: this.userDetails['notes'],
        deliveryInstruction: false,
        storeDetails: this.storeDetails,
        // uuid: !!this.saleOrderUUID ? this.saleOrderUUID : null
      },
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result['status'] === "added") {
        if (this.apiService.loggedIn()) {
          this.saveOrderFunction();          
        }
      }
    });
  }

  updateRecurring() {
    this.router.navigate(['account/recurring']);
  }
  cancel() {
    this.dialogRef.close({value: 'cancel'});
  }
  public close(): void {
    this.dialogRef.close();
  }
  goToSignIn() {
    this.dialogRef.close();
    var queryParams = this.router.url.includes('cart') ? {queryParams:{'redirectURL': this.router.url}} : {};
    this.router.navigate(['sign-in'],queryParams);
  }
  
  imageErrorHandler(event) {
    event.target.src = "https://1dev-order.homemilkdelivery.com/img/no_image_found.png";
  }

  onOpenedChange(isOpened: boolean): void {
    if (isOpened) {
      this.addScrollListener();
    }
  }

  private addScrollListener(): void {
    const panel = document.querySelector('.mat-select-panel');
    if (panel) {
      panel.addEventListener('scroll', () => {
        if (Math.round(panel.scrollTop + panel.clientHeight) >= Math.round(panel.scrollHeight)) {
          this.loadMoreQuantities();
        }
      });
    }
  }

  private loadMoreQuantities(): void {
      const cartQuantity = this.product?.['cart']?.['quantity']; 
      if (this.lastLoadedIndex < this.availableQuantities.length) {
        const nextBatch = this.availableQuantities.slice(
          this.lastLoadedIndex,
          this.lastLoadedIndex + this.batchSize
        ); 
        // Ensure cartQuantity is included in displayedQuantities
        if (cartQuantity && !this.displayedQuantities.includes(cartQuantity)) {
          nextBatch.push(cartQuantity);
        }  
        this.displayedQuantities = [...this.displayedQuantities, ...nextBatch];
        this.lastLoadedIndex += this.batchSize;
    
        // Sort to maintain logical order
        this.displayedQuantities = Array.from(new Set(this.displayedQuantities)).sort((a, b) => a - b);
      }else{
        console.log('Displayed Quantities:', this.displayedQuantities);
      }
  } 

  quantityValidation(event){
    if(this.product['product']['stock_info']['restrict_orders'] == 1){
      if(event.value > this.product['product']['stock_info']['stock_in_hand']){      
        this.notification.warning(`Insufficient quantity. Please reduce the quantity to ${this.product['product']['stock_info']['stock_in_hand']}.`, 5000);
        this.quantityControl.setValue(!!this.product['quantity'] ? this.product['quantity'] : this.product['product']['stock_info']['stock_in_hand']);
      }
    }
  }
  frequencyValidation(event?: any) {  
    const validFrequencies = ['Weekly', 'Every Other Week', 'Monthly', 'Others'];
    if(!!this.featureTags && this.featureTags['sf_product_based_recurring_frequency']){
      const selectedFrequency = event?.value?.frequency || this.frequencyControl.value?.frequency;
    // If selected frequency is in the valid list, enable start date
    if (validFrequencies.includes(selectedFrequency)) {  
      this.isStartDate = true;   
      if (selectedFrequency === 'Others') {  
        this.isMultiSelect = true; // Show multi-select dropdown  
        this.selectedFrequencies = []; // Initialize empty array  
        this.startDateControl.setValue('');  
      } else {  
        this.isMultiSelect = false;  
        this.startDateControl.setValue(this.eventDates?.[0] || '');  
      }  
    } else {  
      this.isStartDate = false;  
    }  
    }else{
      if (validFrequencies.includes(event.value.frequency || this)) {
        this.isStartDate = true;

        if (event.value.frequency === 'Others') {
          this.isMultiSelect = true; // Show the multi-select dropdown
          this.selectedFrequencies = []; // Initialize the array for multiple selections
          this.startDateControl.setValue('');
        } else {
          this.isMultiSelect = false;
          this.startDateControl.setValue(this.eventDates[0]);
        }
      } else {
        this.isStartDate = false;
      }
    }
  
    
  }  
  
  // For handling multiple frequency selection (if needed)
  onMultipleSelectChange(event: any): void {
    if(event.value.length > 0){
      this.selectedFrequencies = event.value;
      this.isButtonDisabled = false;
    }else{
      this.isButtonDisabled = true;
    }
  }
}
